/**
 * Legal document links.
 *
 * The Terms of Service and Privacy Policy live on the marketing site (a
 * separate Next.js app in website/), NOT in this React app. Linking to the
 * bare paths "/terms" and "/privacy" resolves against the app host, where no
 * such route exists — React Router's catch-all then bounces the user to the
 * login page. A prospective client clicking "Terms of Service" during signup
 * would land on a login screen instead of the terms.
 *
 * So these must be absolute. Override with REACT_APP_MARKETING_SITE_URL if the
 * marketing site ever moves or a tenant needs its own legal pages.
 */

const MARKETING_SITE_URL = (
  process.env.REACT_APP_MARKETING_SITE_URL || 'https://www.aimhi.health'
).replace(/\/$/, '');

export const TERMS_URL = `${MARKETING_SITE_URL}/terms`;
export const PRIVACY_URL = `${MARKETING_SITE_URL}/privacy`;

export default { TERMS_URL, PRIVACY_URL, MARKETING_SITE_URL };
